<!-- eslint-disable -->
<template lang="pug">
    .cs-spin-input
        a.input__icon(
            v-if="showDecrease"
            href="javascript://"
            :disabled="value === min"
            :class="(disabled || value === min) && 'input__icon--disabled'"
            @click="decrease"
        )
            svg-icon(name="minus", size="x-large")
        cs-input(
            :class=`[{'input_is-disabled': type === 'text', 'input_big-size': value > 99},width && 'cs-spin-input--width-' + width]`
            :type="type"
            :value="value",
            @input="input",
            @blur="$emit('blur', $event)"
            :max="max"
            :min="min"
            :disabled="disabled"
        )
        a.input__icon(
            v-if="showIncrease"
            href="javascript://"
            :disabled="value === max"
            :class="(disabled || value === max) && 'input__icon--disabled'"
            @click="increase"
        )
            svg-icon(name="plus", size="x-large")
</template>

<script>
    /*eslint-disable*/
    export default {
        props: {
            value: {
                type: [String, Number, Boolean],
                default: null,
            },
            max: {
                type: [Number, String],
                default: null,
            },
            min: {
                type: [Number, String],
                default: null,
            },
            disabled: {
                type: Boolean,
                default: false,
            },
            type: {
                type: String,
                default: 'number',
            },
            width: {
                type: String,
            },
            showDecrease: {
                type: Boolean,
                default: true,
            },
            showIncrease: {
                type: Boolean,
                default: true,
            },
        },
        methods: {
            input(value) {
                if (+value < this.min) {
                    this.$emit('input', this.min);
                    return;
                }
                if (+value > this.max) {
                    this.$emit('input', this.max);
                    return;
                }
                this.$emit('input', +value);
            },
            increase() {
                this.value !== this.max && this.$emit('increase');
            },
            decrease() {
                this.value !== this.min && this.$emit('decrease');
            },
        },
    };
</script>

<style lang="scss" scoped>
    $input-size-map: (
        'xxx-large': (
            140px,
        ),
        'xx-large': (
            120px,
        ),
    );
    .cs-spin-input {
        display: flex;
        flex-direction: row;
        align-items: center;
    }

    .cs-spin-input .cs-input {
        width: 53px;
        height: 41px;
        font-size: 18px;
        margin: 0 10px;
        text-align: center;
        &.input_big-size {
            width: 63px;
        }
    }

    .input__icon {
        color: $hsl-color-blue-56;
        &:hover {
            color: $hsl-color-blue-48;
        }
        .svg-icon {
            margin-top: 5px;
        }
    }

    .input__icon--disabled {
        color: $hsl-color-gray-74;
        &:hover {
            color: $hsl-color-gray-74;
            cursor: auto;
        }
    }

    .input_is-disabled {
        cursor: auto;
        pointer-events: none;
        width: 64px !important;
    }

    @each $name, $size in $input-size-map {
        .cs-spin-input--width-#{$name} {
            width: $size !important;
        }
    }
</style>
